// extracted by mini-css-extract-plugin
export default {"root":"root__1nJzw","arrowIcon":"arrowIcon__Nq6ti"};